const DataFilter_view5_week = (filteredData,selectedDay,view, streamReady) => {
    
    let dataFilter = null;

    if(filteredData!=null){
        
        let dataFilter;

        const monFilter = (dataFilter, day) => {
            const dataByDay = dataFilter.filter(function (data) {
                return data.DMON === day;
            });
            return dataByDay;
        }

        const yearFilter = (dataFilter, year) => {
            const dataByYear = dataFilter.filter(function (data) {
                return data.DYEAR === year || data.DYEAR === year+1;
              });
            return dataByYear;
        }

        const filter_by_cond = (dataFilter) => {
            if( view === 5 ){
                dataFilter = yearFilter(filteredData, selectedDay.DYEAR);
                dataFilter = monFilter(dataFilter, selectedDay.DMON);
                }
            return {dataFilter};
        }

        dataFilter = filter_by_cond(dataFilter);

        return dataFilter;
    
    }

    return {dataFilter};
}
 
export default DataFilter_view5_week;